document.addEventListener("DOMContentLoaded", function () {

  const tabs = document.querySelectorAll(".pd-tab");
  const contents = document.querySelectorAll(".pd-tab-content");

  if (!tabs.length) return;

  // Activate first tab by default
  tabs[0].classList.add("active");
  contents[0]?.classList.add("active");

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {

      const target = this.getAttribute("data-tab");

      // Remove active from all
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      // Activate clicked
      this.classList.add("active");
      document.getElementById(target)?.classList.add("active");
    });
  });

});